<template>
  <el-cascader
    :value="value"
    :options="lists"
    :props="{ checkStrictly: true }"
    @change="handleChange"
    :show-all-levels="showAllChildSelect"
    filterable
    clearable
    size="small"
  >
  </el-cascader>
</template>

<script>
import { serviceQuestFlowStepList } from '@/service/getData'

export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    flowId: {
      type: Number,
      default: 0,
    },
    showAllChildSelect: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    flowId() {
      this.requestData()
    },
  },
  data() {
    return {
      lists: [],
    }
  },
  created() {
    this.requestData()
  },
  mounted() {
    this.$nextTick(() => {
      Array.from(document.getElementsByClassName('el-select')).forEach(
        (item) => {
          item.children[0].children[0].removeAttribute('readOnly')
          item.children[0].children[0].onblur = function () {
            let _this = this
            setTimeout(() => {
              _this.removeAttribute('readOnly')
            }, 200)
          }
        },
      )
    })
  },
  methods: {
    async requestData() {
      if (!this.flowId) {
        this.lists = []
        return
      }
      let res = await serviceQuestFlowStepList({
        service_quest_flow_id: this.flowId,
      })
      if (res.code == 0) {
        this.lists = this.arrayToTree(res.data.list, 0)
      }
    },
    arrayToTree(list, root) {
      let result = [] // 用于存放结果
      const map = {} // 用于存放 list 下的节点

      // 1. 遍历 list，将 list 下的所有节点以 id 作为索引存入 map
      for (const item of list) {
        map[item.id] = { label: item.name, value: item.id } // 浅拷贝
      }

      // 2. 再次遍历，将根节点放入最外层，子节点放入父节点
      for (const item of list) {
        // 3. 获取节点的 id 和 父 id
        const { id, father_id } = item // ES6 解构赋值
        // 4. 如果是根节点，存入 result
        if (item.father_id === root) {
          if (this.showAllChildSelect) {
            result.push({
              label: '所有子流程',
              value: father_id,
            })
          }
          result.push(map[id])
        } else {
          if (!map[father_id].children) {
            map[father_id].children = []
            if (this.showAllChildSelect) {
              map[father_id].children.push({
                label: '所有子流程',
                value: 0,
              })
            }
          }
          map[father_id].children.push(map[id])
        }
      }

      if (!this.showAllChildSelect) {
        result = [{ label: '评估', value: 0, children: result }]
      }
      // 将结果返回
      return result
    },
    handleChange(val) {
      this.$emit('input', val)
      this.$emit('change')
    },
  },
}
</script>